<template>
  <div>
    <div class="position-relative">
      <baniere @oga="nextDevi" />
    </div>
    <avantages id="yourID" />
    <ortherSupport />
    <strategie />
    <marcketing @oga="nextDevi" />
    <sondage />
    <realisations />
    <partenaires />

    <!-- <div id="devis">
      <formulaire />
    </div> -->

    <!-- <equipe /> -->
    <contact />
  </div>
</template>

<script>
import baniere from "@/views/myComponent/baniere";
import avantages from "@/views/myComponent/avantages";
import strategie from "@/views/myComponent/strategie";
import marcketing from "@/views/myComponent/marcketing";
import realisations from "@/views/myComponent/realisations";
// import equipe from "@/views/myComponent/equipe";
import sondage from "@/views/myComponent/sondage";
// import formulaire from "@/views/myComponent/formulaire";
import contact from "@/views/myComponent/contact";
import partenaires from "@/views/myComponent/partenaires";
import ortherSupport from "@/views/myComponent/ortherSupport";

export default {
  name: "home",
  components: {
    baniere,
    avantages,
    strategie,
    marcketing,
    realisations,
    // equipe,
    sondage,
    // formulaire,
    contact,
    partenaires,
    ortherSupport,
  },

  methods: {
    nextBloc(answer) {
      let element = document.getElementById("yourID");
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },

    nextDevi(answer) {
      let element = document.getElementById("devis");
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
  },
};
</script>
<style></style>
